import beverages from './beverages.jpg'
import breakfast from './breakfast.jpg'
import main from './main.jpeg'
import outlay from './outlay.jpeg'
import male from './male.png'
import company from './company.png'
import company_alt from './company_alt.png'
import male_alt from './male_alt.png'
import female from './female.png'
import female_alt from './female_alt.png'
import logo from './logo.png'
import logoLight from './logo-light.png'

let images = {
    beverages,
    breakfast,
    main,
    outlay,
    logo,
    logoLight,
    male,
    male_alt,
    female,
    female_alt,
    company,
    company_alt
}

export default images